@let user = user$ | async;
@let hasAccount = hasAccount$ | async;

<mds-dialog dialogTitle="{{ claimsData?.email ? 'No Role Assignment' : 'Wrong Login Method' }}">
    <mds-dialog-content>
        <div class="o-grid__row">
            <div class="o-grid__item text-center">
                <h5>
                    <span class="no_role_user_name" id="UserNoRoleName">
                        {{ hasAccount ? user?.fullName : claimsData?.fullName }}
                    </span>
                </h5>
            </div>
        </div>

        @if (claimsData?.email) {
            <div class="o-grid__row">
                <div class="o-grid__item text-left">
                    <h5>If you are Medpace internal user, please create an access request.</h5>
                </div>
            </div>
        } @else {
            <div class="o-grid__row">
                <div class="o-grid__item text-left">
                    <h5>If you are a CRC user, please sign in with your email.</h5>
                </div>
            </div>
        }
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        @if (claimsData?.email) {
            <div class="flex flex-row gap-medpace">
                <mds-button
                    mat-button
                    mat-dialog-close
                    [id]="'NoRoleLogoutButton'"
                    label="Logout"
                    variant="outline"
                    color="neutral"
                    (clickEvent)="initLogout()"
                ></mds-button>
                @if (isSSOAuthenticated) {
                    <mds-button
                        [id]="'CreateAccessRequestBtn'"
                        label="Create access request"
                        [color]="'primary'"
                        [variant]="'filled'"
                        (clickEvent)="accessReqeustPage()"
                    ></mds-button>
                }
            </div>
        } @else {
            <div class="flex flex-row gap-medpace">
                <mds-button
                    mat-button
                    mat-dialog-close
                    [id]="'CloseButton'"
                    label="Close"
                    [color]="'primary'"
                    [variant]="'filled'"
                    (clickEvent)="initLogout()"
                ></mds-button>
            </div>
        }
    </mds-dialog-actions>
</mds-dialog>
